import script from "./ConfirmRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmRegister.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmRegister.vue?vue&type=style&index=0&id=644f246a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-644f246a"]])

export default __exports__